export const infoApi = {
    fetchInstitutes: false,
};
